import { Entity, IEntity } from "./Entity";
import { IUser } from "./User";
import { IPartnerOrganisation } from "./PartnerOrganisation";
import { IPartnerOrganisationUpdate } from "./PartnerOrganisationUpdate";
import { IPartnerOrganisationRiskUpdate } from "./PartnerOrganisationRiskUpdate";
import { IPartnerOrganisationRiskMitigationActionUpdate } from "./PartnerOrganisationRiskMitigationActionUpdate";
import { IRiskUpdate } from "./RiskUpdate";
import { IRiskMitigationActionUpdate } from "./RiskMitigationActionUpdate";
import { IDirectorate } from "./Directorate";
import { IProject } from "./Project";
import { IDirectorateUpdate } from "./DirectorateUpdate";
import { IProjectUpdate } from "./ProjectUpdate";
import { IKeyWorkAreaUpdate } from "./KeyWorkAreaUpdate";
import { IWorkStreamUpdate } from "./WorkStreamUpdate";
import { IMetricUpdate } from "./MetricUpdate";
import { IBenefitUpdate } from "./BenefitUpdate";
import { IMilestoneUpdate } from "./MilestoneUpdate";
import { ICommitmentUpdate } from "./CommitmentUpdate";
import { IDependencyUpdate } from "./DependencyUpdate";
import { IKeyWorkArea } from "./KeyWorkArea";
import { IBenefit } from "./Benefit";
import { ICommitment } from "./Commitment";
import { IDependency } from "./Dependency";
import { IMetric } from "./Metric";
import { IMilestone } from "./Milestone";
import { IPartnerOrganisationRisk } from "./PartnerOrganisationRisk";
import { IPartnerOrganisationRiskMitigationAction } from "./PartnerOrganisationRiskMitigationAction";
import { IWorkStream } from "./WorkStream";
import { ICorporateRisk } from "./CorporateRisk";
import { IFinancialRisk } from "./FinancialRisk";
import { ICustomReportingEntityType } from "./CustomReportingEntityType";
import { IFinancialRiskMitigationAction } from "./FinancialRiskMitigationAction";
import { ICorporateRiskMitigationAction } from "./CorporateRiskMitigationAction";
import { IPortfolio, IPortfolioUpdate, IProgramme, ISignOffDto } from ".";
import { IProgrammeUpdate } from "./ProgrammeUpdate";

export interface ISignOff extends IEntity {
    SignOffDate: Date | null;
    SignOffUserID: number | null;
    ReportMonth: Date | null;
    DirectorateID: number | null;
    ProjectID: number | null;
    PortfolioID: number | null;
    ProgrammeID: number | null;
    PartnerOrganisationID: number | null;
    RiskID: number | null;
    SignOffEntities: string | null;
    ReportJson: string | null;
    SignOffUser?: IUser;
    Directorate?: IDirectorate;
    Project?: IProject;
    Portfolio?: IPortfolio;
    Programme?: IProgramme;
    PartnerOrganisation?: IPartnerOrganisation;
    Risk?: ICorporateRisk;
    FinancialRisk?: IFinancialRisk;
    DirectorateUpdates?: IDirectorateUpdate[];
    ProjectUpdates?: IProjectUpdate[];
    PortfolioUpdates?: IPortfolioUpdate[];
    ProgrammeUpdates?: IProgrammeUpdate[];
    PartnerOrganisationUpdates?: IPartnerOrganisationUpdate[];
    KeyWorkAreaUpdates?: IKeyWorkAreaUpdate[];
    WorkStreamUpdates?: IWorkStreamUpdate[];
    MetricUpdates?: IMetricUpdate[];
    BenefitUpdates?: IBenefitUpdate[];
    MilestoneUpdates?: IMilestoneUpdate[];
    CommitmentUpdates?: ICommitmentUpdate[];
    DependencyUpdates?: IDependencyUpdate[];
    RiskUpdates?: IRiskUpdate[];
    RiskMitigationActionUpdates?: IRiskMitigationActionUpdate[];
    PartnerOrganisationRiskUpdates?: IPartnerOrganisationRiskUpdate[];
    PartnerOrganisationRiskMitigationActionUpdates?: IPartnerOrganisationRiskMitigationActionUpdate[];

    // From decompose of ReportJson
    Benefits?: IBenefit[];
    Commitments?: ICommitment[];
    Dependencies?: IDependency[];
    FinancialRiskMitigationActions?: IFinancialRiskMitigationAction[];
    KeyWorkAreas?: IKeyWorkArea[];
    Metrics?: IMetric[];
    Milestones?: IMilestone[];
    Projects?: IProject[];
    Portfolios?: IPortfolio[];
    Programmes?: IProgramme[];
    PartnerOrganisationRisks?: IPartnerOrganisationRisk[];
    PartnerOrganisationRiskMitigationActions?: IPartnerOrganisationRiskMitigationAction[];
    ReportingEntityTypes?: ICustomReportingEntityType[];
    RiskMitigationActions?: ICorporateRiskMitigationAction[];
    WorkStreams?: IWorkStream[];
}

export class SignOff extends Entity implements ISignOff {
    public SignOffDate = null;
    public SignOffUserID = null;
    public ReportMonth: Date | null = null;
    public DirectorateID = null;
    public ProjectID = null;
    public PortfolioID = null;
    public ProgrammeID = null;
    public PartnerOrganisationID = null;
    public RiskID = null;
    public SignOffEntities = null;
    public ReportJson = null;

    constructor(reportMonth: Date) {
        super();
        this.ReportMonth = reportMonth;
    }
}

export class SignOffEntity {
    public EntityType:string  | null = null;
    public EntityID: number | null = null;

    constructor(entityType: string, entityID: number) {
        this.EntityType = entityType;
        this.EntityID = entityID;
    }
}

export interface ISignOffAndMetadata {
    report: Partial<ISignOff>;
    metadata: ISignOffDto;
}